import { Container } from '@cgs/wge';
import { CheatActiveUI } from './ui/cheat-active';
import { CheatCommandsUI } from './ui/cheat-commands';
import { CheatConfigsUI } from './ui/cheat-configs';
import { CheatCustomInputUI } from './ui/cheat-custom-input';
import { CheatFastSpinUI } from './ui/cheat-fast-spin';
import { CheatReelsUI } from './ui/cheat-reels';
import { ICheatUISection } from './ui/cheat-ui-section';

export const CheatUIManagerToken = Symbol('CheatUIManager');
export class CheatUIManager {
  public sections: ICheatUISection[] = [];

  constructor(public container: Container) {
    this.initialize();
  }

  public initialize(): void {
    this.sections.push(new CheatActiveUI(this.container));
    this.sections.push(new CheatConfigsUI(this.container));
    this.sections.push(new CheatCommandsUI(this.container));
    this.sections.push(new CheatReelsUI(this.container));
    this.sections.push(new CheatFastSpinUI(this.container));
    this.sections.push(new CheatCustomInputUI(this.container));

    this.initializeAdvance();
  }

  public initializeAdvance(): void {
    //this.sections.push(new CustomCheatUISection(this.container));
  }

  public destroy(): void {
    this.sections.forEach((section) => section.destroy());
  }
}
